import React from "react";
import { Bar } from "react-chartjs-2";
import { STATUS_OPTION, STEP_OPTION, statusOptions } from "../../../components/buckets/constants";
import { dataForDayTemplate } from "../chartTemplates";

export function WeekStatus({filteredBuckets}){

    const options =  {
        scales: {
            y: {
            beginAtZero: true
            }
        }
    }
      
      function calculateColorTotal(filteredBuckets2){
        let colorTotals = filteredBuckets2.reduce((acc,v,i,arr)=>{
            acc[v.weekActionStatus] = acc[v.weekActionStatus] + 1
            return acc
          }
          ,
          {
            black:0,
            purple:0,
            red:0,
            white:0,
            yellow:0,
            green:0,
            blue:0
          })
          return colorTotals
        }
    let dataObjectForWeek = calculateColorTotal(filteredBuckets)
    let dataArrayForWeek = statusOptions.map(color => dataObjectForWeek[color])
  



    return <Bar
              type="bar"
              options={options}
              data={dataForDayTemplate(dataArrayForWeek, statusOptions,statusOptions,"Week Action Points by Colour")}
              />
}